<div [ngClass]="{ 'login-router': !fromPlaceAd }">
	<div class="login-banner" *ngIf="!fromPlaceAd">
		<img class="city-frame" [src]="'assets/images/login/Frame.png' | s3Image" alt="" />
		<div class="user-frame">
			<div>
				<img [src]="'assets/images/login/Group 45711.svg' | s3Image" alt="" />
			</div>
			<h4 class="text-white text-center">{{ locale.translations['logup']['login']['n51'] }}</h4>
		</div>
	</div>

	<app-place-ad-stepper *ngIf="fromPlaceAd"></app-place-ad-stepper>

	<app-auth-layout
		[navigationData]="{
		fromPricing,
		queryPackage,
		redirect,
		assignAd,
		embedded
	}"
	></app-auth-layout>
</div>
